import axios from 'axios';
import { IGroundWaterZoneUpsert } from '../../@types/model/borehole/groundWaterZone/groundWaterZoneUpsert';
import { IGroundWaterZone } from '../../@types/model/borehole/groundWaterZone/groundWaterZone';
import { UpsertTypeEnum } from '../../@types/enum/upsertType';

export default class GroundWaterZoneHttpService {
    public static getList = async () : Promise<Array<IGroundWaterZone>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/GroundWaterZone/GetList`);
        return result.data;
    }

    public static upsert = async (upsert : IGroundWaterZoneUpsert, type : UpsertTypeEnum) : Promise<IGroundWaterZone> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/GroundWaterZone/${type}`, upsert);
        return result.data;
    }

    public static delete = async (groundwaterZoneId : number) : Promise<void> => {
        await axios.delete(`${API_URL}/v1/MasterData/GroundwaterZone/Delete`, {
            params: {
                groundwaterZoneId,
            },
        });
    }
}
